<template>
    <div class="common-page">
        <div class="wrapper" style="padding-bottom: 40px">
            <h1>Serviços</h1>
            <div class="flex">
                <div>
                    <template v-for="(service, index) in services">
                        <h2 :key="index" :id="service.name"><i :class="service.class"></i> {{ service.name }}</h2>
                        <p :key="index" v-html="service.description"></p>
                    </template>
                </div>
                <img src="https://firebasestorage.googleapis.com/v0/b/vacuum-center.appspot.com/o/public%2Fsupport-01.svg?alt=media&token=8c7b8b39-c0ed-406c-a358-621336a56cb4" alt="Suporte">
            </div>
        </div>
        <get-in-touch></get-in-touch>
    </div>
</template>
<script>
import GetInTouch from '../components/GetInTouch.vue'
export default {
    name: "Services",
    components: {
        GetInTouch
    },
    data(){
        return {
            services: [],
            loading: true
        }
    },
    
    mounted(){
        this.loadServices()
    },
    methods:{
        loadServices(){
            this.loading = true
            this.$db.collection("services").get().then((snap) => {
                let service = []
                this.loading = true
                snap.forEach((doc) => {
                    let data = doc.data()
                    data.docId = doc.id
                    service.push(data)
                });

                this.services = service
                this.loading = false
            })
        }
    }
}
</script>
<style scoped>
    img{
        display: block; 
        margin: 10px 0 0 50px;
    }
    i{
        color: #ced2de;
    }
</style>